const PREFIX = "WORKING_SCHEDULE"
const WORKING_SCHEDULE_TYPES = {
  ADD_WORKLOAD: `${PREFIX}/ADD_WORKLOAD`,
}

export default WORKING_SCHEDULE_TYPES